export default __webpack_public_path__ + "static/media/Logo.500cb8b2.png";